export default "__VITE_ASSET__DTKroEtu__"